import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from './App';
import configureStore from "../src/store/configureStore"
import TagManager from 'react-gtm-module'

const store = configureStore()
// const tagManagerArgs = {
//   gtmId: process.env.REACT_APP_IDGTM,
//   dataLayer: {
//     userProject: 'Chifco_website'
// }

// }

//TagManager.initialize(tagManagerArgs)
ReactDOM.render(
  <Provider store={store}>
      <App />
  </Provider>

, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js